import React from 'react';

import { useSelector } from 'react-redux';
import { getEntityUrl } from '@culture/utils/helpers/entities';
import { appSelectors } from 'ducks/app';
import { IntituteType } from 'propTypes/entities';
import BaseCard from '../BaseCard';

const InstituteCard = ({ institute }) => {
	const {
		_id,
		title,
		name,
		thumbnailFile,
		type,
		locale,
		foundationDate
	} = institute;
	const redirectUrl = useSelector(appSelectors.selectRedirectUrl);

	const entityUrl = `${redirectUrl}${getEntityUrl('institutes', {
		_id,
		name,
		type
	})}`;

	return (
		<BaseCard
			title={title}
			location={locale?.title}
			thumbnailFile={thumbnailFile}
			thumbnailParams={{ width: 540, height: 270 }}
			url={entityUrl}
			foundationDate={foundationDate}
			type="institute"
			showLink={false}
			isSlider
		/>
	);
};

InstituteCard.propTypes = {
	institute: IntituteType.isRequired
};

export default InstituteCard;
